import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController,AlertController } from 'ionic-angular';
import { Http,Headers, RequestOptions } from "@angular/http";
import config from "../../config/config";
import { HomePage } from "../home/home";


/**
 * Generated class for the PlebiscitoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-plebiscito',
  templateUrl: 'plebiscito.html',
})
export class PlebiscitoPage {
  usuario:any;
  grupo:any;
  returnvalues:any;
  opcoes:any;
  opcoesForm;
  env:any;
  constructor(
    public navCtrl: NavController,
     public navParams: NavParams,
    private alertCtrl: AlertController,

     private _http: Http,
     public loadingCtrl: LoadingController,
     ) {

  }

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.grupo = this.navParams.get("grupo");
    this.getPlebiscito()
  }

  getPlebiscito(){
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    let options = new RequestOptions({headers: new Headers(headerDict)})

    
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "listar/plebiscito",  options)
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.returnvalues = res[0];
        this.opcoes = JSON.parse(this.returnvalues.opcoes)
        loading.dismiss();

      })
      .catch(error => {
        console.log(error)
        loading.dismiss();

      });
  }
  enviar(val) {
    if (val) {
      let env = {
        "user_id":this.usuario.id,
        "opcao":val,
        "plebiscito_id":this.returnvalues.id
    }
    this.submit(env);
      
    }else{
      let alert = this.alertCtrl.create({
        title: "Obrigatórios",
        subTitle: "Selecione uma das opções",
        buttons: [
          {
            text: "OK",
            handler: data => { }
          }
        ]
      });
      alert.present();
    }
  }
  submit(env){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .post(config.urlAPI + "voto/plebiscito", env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        loading.dismiss();
        let alert = this.alertCtrl.create({
          title: "Obrigado",
          subTitle: "por participar do nosso plebiscito sua opinão foi computada",
          enableBackdropDismiss: false,
          buttons: [
            {
              text: "OK",
              handler: data => {
                this.goHome()
               }
            }
          ]
        });
        alert.present();

      })
      .catch(error => {
        console.log(error)
        loading.dismiss();

      });
  }
  goHome(){
    this.navCtrl.setRoot(HomePage, {


    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/plebiscito/plebiscito.ts